/* Osmo Toggle Switch: follow native radio selection instead of replacing it.
   Never select the first size, mutate variant IDs, or intercept pointer/keyboard input. */
(function () {
  if (window.SPQRSelectionMotion) {
    window.SPQRSelectionMotion.init();
    window.SPQRSelectionMotion.refresh();
    return;
  }
  var instances = new Map();
  function init(group) {
    if (instances.has(group)) return;
    var inputs = Array.from(group.querySelectorAll('input[type="radio"][data-variant-input]'));
    var labels = inputs.map(function (input) { return input.nextElementSibling; });
    if (inputs.length < 2 || labels.some(function (label) { return !label || !label.matches('label.variant__button-label') || label.classList.contains('color-swatch'); })) return;
    var indicator = document.createElement('div');
    indicator.className = 'toggle-switch__bg';
    indicator.setAttribute('aria-hidden', 'true');
    group.appendChild(indicator);
    group.setAttribute('data-toggle-init', '');
    group.setAttribute('data-spqr-selection-ready', '');
    group.style.setProperty('--toggle-count', inputs.length);
    labels.forEach(function (label) { label.setAttribute('data-toggle-btn', ''); });
    var frame = 0, resizeFrame = 0, resizeEndFrame = 0;
    function update() {
      frame = 0;
      var index = inputs.findIndex(function (input) { return input.checked; });
      labels.forEach(function (label, i) { label.toggleAttribute('data-toggle-active', i === index); });
      group.style.setProperty('--toggle-active', index);
      if (index < 0) { group.removeAttribute('data-toggle-selected'); return; }
      var bounds = labels[index].getBoundingClientRect(), parent = group.getBoundingClientRect();
      if (!bounds.width || !bounds.height) { group.removeAttribute('data-toggle-selected'); return; }
      group.style.setProperty('--spqr-toggle-x', (bounds.left - parent.left - group.clientLeft + group.scrollLeft) + 'px');
      group.style.setProperty('--spqr-toggle-y', (bounds.top - parent.top - group.clientTop + group.scrollTop) + 'px');
      group.style.setProperty('--spqr-toggle-width', bounds.width + 'px');
      group.style.setProperty('--spqr-toggle-height', bounds.height + 'px');
      group.toggleAttribute('data-toggle-unavailable', inputs[index].disabled || inputs[index].classList.contains('disabled') || labels[index].classList.contains('disabled'));
      group.setAttribute('data-toggle-selected', '');
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    function resize() {
      group.setAttribute('data-toggle-resizing', '');
      schedule();
      cancelAnimationFrame(resizeFrame); cancelAnimationFrame(resizeEndFrame);
      resizeFrame = requestAnimationFrame(function () { resizeEndFrame = requestAnimationFrame(function () { group.removeAttribute('data-toggle-resizing'); }); });
    }
    group.addEventListener('change', schedule);
    var observer = new MutationObserver(schedule);
    inputs.forEach(function (input) { observer.observe(input, {attributes: true, attributeFilter: ['checked', 'disabled', 'class']}); });
    labels.forEach(function (label) { observer.observe(label, {attributes: true, attributeFilter: ['class']}); });
    var dimensions = window.ResizeObserver ? new ResizeObserver(resize) : null;
    if (dimensions) { dimensions.observe(group); labels.forEach(function (label) { dimensions.observe(label); }); }
    else window.addEventListener('resize', resize);
    instances.set(group, {schedule: schedule, destroy: function () {
      cancelAnimationFrame(frame); cancelAnimationFrame(resizeFrame); cancelAnimationFrame(resizeEndFrame);
      group.removeEventListener('change', schedule); observer.disconnect();
      if (dimensions) dimensions.disconnect(); else window.removeEventListener('resize', resize);
      indicator.remove();
      ['data-toggle-init','data-spqr-selection-ready','data-toggle-selected','data-toggle-unavailable','data-toggle-resizing'].forEach(function (attribute) { group.removeAttribute(attribute); });
      labels.forEach(function (label) { label.removeAttribute('data-toggle-btn'); label.removeAttribute('data-toggle-active'); });
    }});
    resize();
  }
  function boot() { document.querySelectorAll('.variant-input-wrap').forEach(init); }
  function refresh() { instances.forEach(function (instance, group) { if (group.isConnected) instance.schedule(); }); }
  window.SPQRSelectionMotion = {init: boot, refresh: refresh};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('spqr:selection', refresh);
  document.addEventListener('variant:change', refresh);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('quickview:loaded', boot);
  document.addEventListener('quickview:open', refresh);
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (instance, group) { if (event.target.contains(group)) { instance.destroy(); instances.delete(group); } });
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
})();
